import axios from 'axios';
import { API_URL } from '../config/api';

const markedDeliveredIds = new Set();

const isServerMessageId = (id) => {
  if (!id) return false;
  const s = String(id);
  return !s.startsWith('temp-') && !s.startsWith('pending-');
};

/**
 * Confirm this device received a peer message (DM delivery tick for the sender).
 * Idempotent; safe to call from WS and list hydration.
 */
export const acknowledgeMessageDelivered = async (message, currentUserId) => {
  if (!message?.id || !currentUserId) return;
  if (!isServerMessageId(message.id)) return;
  if (String(message.senderId) === String(currentUserId)) return;

  const already =
    Array.isArray(message.deliveredBy) &&
    message.deliveredBy.some((id) => String(id) === String(currentUserId));
  if (already || markedDeliveredIds.has(message.id)) return;

  markedDeliveredIds.add(message.id);
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      markedDeliveredIds.delete(message.id);
      return;
    }
    await axios.put(
      `${API_URL}/messages/${message.id}/delivered`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch (error) {
    markedDeliveredIds.delete(message.id);
    console.warn('Failed to acknowledge message delivery:', error?.message || error);
  }
};
